/**
 * A mixin for formatting filter labels
 */
export default {
  methods: {
    getFormattedFilterLabel () {
      return ''
    },
    getFormattedFilterValue (list, label) {
      if (list.length === 0) return label
      else return `${label} (${list.length})`
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/search/FilterLabelFormatter.js